import { render, staticRenderFns } from "./IconSection.vue?vue&type=template&id=0aa25c80&scoped=true&"
import script from "./IconSection.vue?vue&type=script&lang=js&"
export * from "./IconSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa25c80",
  null
  
)

export default component.exports